import { useTranslation } from 'react-i18next';
import { useModal } from 'context/ModalContext';
import { getButtonsNoYesDanger } from 'context/helpers/helperModalContext';
import SvgTrash from 'components/svg/SvgTrash';
import type { LeadType } from '@econtractor/types';

type DeleteCallback = () => void | Promise<void>;

const useDeleteLead = () => {
    const { t } = useTranslation(['Leads']);
    const { showDlg } = useModal();

    const paramsDelDlg = {
        buttons: [...getButtonsNoYesDanger(t)],
        type: 'confirm',
    };

    const deleteLead = (lead: LeadType, cbFunct: DeleteCallback) => {
        const p: any = {
            ...paramsDelDlg,
            text: (
                <>
                    <h4 className="d-flex pb-2 mb-2 border-bottom text-danger">
                        <SvgTrash className="text-danger" />
                        <span className="ps-2">{t('leadPopup.delete')}?</span>
                    </h4>
                    <h5 className="mb-0">{lead.clientName}</h5>
                    <small className="form-text text-muted">{lead.clientPhone}</small>
                </>
            ),
        };
        p.buttons[1].handleClick = () => {
            showDlg(false);
            cbFunct();
        };
        showDlg(p);
    };

    return {
        deleteLead,
    };
};

export default useDeleteLead;
